import { Box, MenuItem, TextField } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';
import SearchInput from '../../Components/SearchInput';

export default function Search({
    filters,
    setFilters
}) {
    const [t] = useTranslation("common");

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100% !important",
            }}
        >
            <SearchInput
                value={filters?.account_name}
                setValue={(value) => {
                    setFilters({
                        ...filters,
                        account_name: value
                    })
                }}
                title={t('ACCOUNTS.name') || "اسم الحساب"}
            />
            
            <TextField
                select
                sx={{ ml: 1.5, mt: 1, mb: 1, width: '95%' }}
                label={t('ACCOUNTS.is_governmental') || "حكومي"}
                value={filters.is_governmental ?? ""}
                onChange={(e) => setFilters({ ...filters, is_governmental: e.target.value === "" ? null : e.target.value })}
                variant="standard"
            >
                <MenuItem value="">{t('GLOBAL.all') || "الكل"}</MenuItem>
                <MenuItem value={1}>{t('GLOBAL.yes') || "نعم"}</MenuItem>
                <MenuItem value={0}>{t('GLOBAL.no') || "لا"}</MenuItem>
            </TextField>
        </Box>
    );
}
